import ReadSpeaker from "views/readspeaker";

export default function (options) {
  if (ReadSpeaker.available) {
    return options.fn(this);
  } else {
    return options.inverse(this);
  }
}
